var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelamentoKits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 81,
    fill: "#DFFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21C5E5",
    d: "M54.646 40.426h31.04v25.418l7.624-7.933 7.385 7.933V40.426h6.95v81h-53z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009BBF",
    strokeWidth: 3,
    d: "M55.646 36.926a3.5 3.5 0 0 0-3.5 3.5v81a3.5 3.5 0 0 0 3.5 3.5h52a3.5 3.5 0 0 0 3.5-3.5v-81a3.5 3.5 0 0 0-3.5-3.5h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009BBF",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M61.146 39.223v86.138"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009BBF",
    strokeWidth: 3,
    d: "M88.146 37.926v21.613l5-5.513 5 5.513V37.926h-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelamentoKits);
export default __webpack_public_path__ + "static/media/cancelamento-kits.280cecb76391fc814ef7f619c38381d1.svg";
export { ForwardRef as ReactComponent };